
export function ClickOutside() {
    return {
        priority: 700,
        event: undefined,

        bind: function(el, binding, vnode) {
            console.log('bind')
            console.log(vnode)
            let self  = binding.def;
            self.event = function (event) {
                vnode.context.$emit(binding.expression, event) 
                this.showEmojiWindow = false
            }
            el.addEventListener('click', self.stopProp)
            document.body.addEventListener('click', self.event)
        },

        unbind: function(el, binding, vnode) {
            let self  = binding.def;
            el.removeEventListener('click', self.stopProp)
            document.body.removeEventListener('click', self.event)
        },

        stopProp: function(event) {
            event.stopPropagation() 
        }
    };
}